/* Lightweight phone motion for the accessible flat stage. */
(function () {
  'use strict';
  function boot() {
    var stage = document.querySelector('[data-sash-stage]');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!stage || !window.matchMedia('(max-width: 679px)').matches) return;
    var cards = Array.prototype.slice.call(stage.querySelectorAll('.sash-stage__flat .sash-panel__card'));
    if (!cards.length) return;

    cards.forEach(function (card, i) {
      card.classList.add('sash-mobile-card');
      card.style.setProperty('--sash-delay', Math.min(i * 45, 360) + 'ms');
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      cards.forEach(function (card) { observer.observe(card); });
    } else {
      cards.forEach(function (card) { card.classList.add('is-visible'); });
    }

    var ticking = false;
    function parallax() {
      ticking = false;
      var h = window.innerHeight || 1;
      cards.forEach(function (card) {
        if (!card.classList.contains('is-visible')) return;
        var r = card.getBoundingClientRect();
        if (r.bottom < -80 || r.top > h + 80) return;
        var center = r.top + r.height / 2;
        var shift = Math.max(-10, Math.min(10, (h / 2 - center) * 0.035));
        card.style.setProperty('--sash-shift', shift.toFixed(1) + 'px');
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(parallax); }
    }, { passive: true });
    window.addEventListener('resize', parallax, { passive: true });
    parallax();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
